import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BeatLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCartShopping,
  faHospital,
  faUtensils,
  faSchool,
  faMapMarkerAlt,
  faMap,
} from '@fortawesome/free-solid-svg-icons';

import { fetchLocalityData } from '../../../../utils/fetchLocalityData';

import { LocalityData } from './localityTypes';
import './NearbyLocality.css';

const DRIVE_FILE_ID = '1aZB1j0Kj3qMClGwye_nbxWzTH4atFUG1';

const categoryIcons: Record<string, any> = {
  Groceries: faCartShopping,
  Hospitals: faHospital,
  Restaurants: faUtensils,
  Schools: faSchool,
};

const NearbyLocality = () => {
  const [localityData, setLocalityData] = useState<LocalityData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadLocalityData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchLocalityData(DRIVE_FILE_ID);
        setLocalityData(data);
      } catch (error) {
        console.error('Failed to load locality data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadLocalityData();
  }, []);

  return (
    <Container className="nearby-locality-section">
      <div className="nearby-header">
        <h3>What&apos;s Nearby</h3>
        <p className="nearby-subtitle">
          Discover convenient amenities in your neighborhood
        </p>
      </div>

      {isLoading ? (
        <div className="text-center my-5">
          <BeatLoader color="#0d6efd" size={15} margin={2} />
        </div>
      ) : (
        <Row className="g-4">
          {localityData?.nearbyLocalities.map((category, index) => (
            <Col key={index} xs={12} sm={6} lg={4}>
              <div className="locality-card">
                <div className="locality-card-header">
                  <h3 className="locality-card-title">
                    <FontAwesomeIcon
                      icon={categoryIcons[category.category] || faMap}
                      className="fa-lg icon-spacing-right"
                    />
                    {category.category}
                  </h3>
                </div>

                <div className="locality-card-body">
                  <ul className="locality-list">
                    {category.places.map((place, idx) => (
                      <li key={idx} className="locality-item">
                        <div className="locality-item-left">
                          <FontAwesomeIcon
                            icon={faMapMarkerAlt}
                            className="fa-sm"
                          />
                          <p className="locality-item-name">{place.name}</p>
                        </div>
                        <span className="locality-item-distance">
                          {place.distance}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default NearbyLocality;
